import React, {useState} from "react"

function DownloadModule(props) {
    const [downloadText] = useState("Download & print the latest evidence")
    const [envelopeText] = useState("Open envelope " + props.currentPage + " NOW to see the latest evidence")
    const [downloadIcon] = useState("images/icons/import.png")
    const [envelopeIcon] = useState("images/icons/information.png")
    
    const text = props.playerPrint ? downloadText : envelopeText
    const icon = props.playerPrint ? downloadIcon : envelopeIcon
    
    return (
        <div>
            <div id="downloadWrapper">
                <img src={icon} alt="a download logo" />
                <div id="downloadModuleText">
                    <h2>WAIT!</h2>
                    <h3>{text}</h3>
                </div>
                {props.playerPrint ? <button className="standardButton" onClick={props.handleDownload} value={props.currentPage}>Download</button> : <img src={icon} alt="a download logo" />}
            </div>

            <div className={"colourStripe " + props.barColor} onClick={props.unlockPartFour}/>
        </div>
    )
}

export default DownloadModule